import { useFormContext } from "react-hook-form";
import React, { memo, useEffect } from "react";
import Hint from "@/shared/ui/hint";
import {
  NewOrderAttributes,
  NewOrderScenario,
  TNewOrderForm,
} from "@/entities/new-order";
import { Checkbox } from "@/shared/ui/checkbox";
import { TAttributesRows } from "@/widgets/create-order-form/model/types";
import { getAppStore } from "@/shared/helpers";
import { useAppSelector } from "@/Hooks/redux/useAppSelector";
import styles from "./attributes-block.module.scss";

export const GoogleAttributes = memo(
  ({
    attributesList,
    handleCheckboxChange,
    handleDeleteAttribute,
  }: TAttributesRows) => {
    const { user } = useAppSelector((state) => state.clientDataSlice);
    const { watch, setValue } = useFormContext<TNewOrderForm>();

    const {
      app,
      activeScenario,
      attributesList: currentAttributesList,
    } = watch();

    useEffect(() => {
      if (!app || getAppStore(app.url) === "apple") {
        // Удаляем оба атрибута за один раз
        const filteredList = currentAttributesList.filter(
          (attr) =>
            attr !== NewOrderAttributes.Retention &&
            attr !== NewOrderAttributes.ConsoleVisible,
        );

        // Обновляем только если есть изменения
        if (filteredList.length !== currentAttributesList.length) {
          setValue("attributesList", filteredList);
        }
      }
    }, [app, currentAttributesList, setValue]);

    return (
      <>
        <div className={styles.row}>
          <div className={styles.row_heading}>
            <div className={styles.heading}>
              <span className={styles.title}>Console visibility</span>
              <Hint popupText="select this option if you want the installation information to be displayed in the Google Play console" />
            </div>
            <Checkbox
              name="attributes"
              value={NewOrderAttributes.ConsoleVisible}
              checked={attributesList.includes(
                NewOrderAttributes.ConsoleVisible,
              )}
              onChange={handleCheckboxChange}
              isDisabled={
                !app ||
                getAppStore(app.url) === "apple" ||
                activeScenario === NewOrderScenario.extend
              }
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.row_heading}>
            <div className={styles.heading}>
              <span className={styles.title}>Retention</span>
              <Hint
                popupText={`After Installation Retention.Select this option to give the app special attention and maximum retention after installation. Adds ${user?.retention_cost}$ to the installation cost.`}
              />
            </div>
            <Checkbox
              name="attributes"
              value={NewOrderAttributes.Retention}
              checked={attributesList.includes(NewOrderAttributes.Retention)}
              onChange={handleCheckboxChange}
              isDisabled={
                !app ||
                getAppStore(app.url) === "apple" ||
                activeScenario === NewOrderScenario.extend
              }
            />
          </div>
        </div>
      </>
    );
  },
);

GoogleAttributes.displayName = "GoogleAttributes";
